// @flow

import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';

export function indiaOutgoingPaymentMapper(userInputValues: UserInputValues): $Shape<OutgoingPayment> {
  return {
    country: 'in',
    phone_number: userInputValues['indiaPhoneNumber'],
    metadata: {
      upi_vpa: userInputValues['indiaUpiId'] !== undefined ? userInputValues['indiaUpiId'] : '',
    },
    zipcode: userInputValues['indiaZipcode'],
    state: userInputValues['indiaState'],
    address: userInputValues['indiaAddress'],
    street_complement: userInputValues['indiaStreetComplement'],
    city: userInputValues['indiaCity'],
  };
}
